import React from 'react';
import PropTypes from 'prop-types';

import Input from '../../../../../components/Input';
import ErrorLabel from '../../components/ErrorLabel';
import messages from '../messages';
import { addHttpToUrl } from '../../../../../utils/url';

import '../../styles.css';

const WebsiteComponent = ({
  name,
  value,
  onChange,
  stylesName,
  subheading,
  placeholder,
  showError,
}) => {
  const onBlur = (e) => {
    if (value) {
      const url = addHttpToUrl(value);

      if (url !== value) {
        onChange(e, { value: url });
      }
    }
  };

  return (
    <div
      styleName={stylesName}
      data-cy={`Premium-Hem-${name}-Website-Container`}
    >
      {subheading && <p>{subheading}</p>}
      <Input
        data-cy={`Premium-Hem-${name}-InputField`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      {showError && <ErrorLabel error={{ ...messages.invalidUrlError }} />}
    </div>
  );
};

WebsiteComponent.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  stylesName: PropTypes.string,
  subheading: PropTypes.string,
  placeholder: PropTypes.string,
  showError: PropTypes.bool,
};

export default WebsiteComponent;
